<template>
  <div>
    <AdminTable />
  </div>
</template>

<script>
import AdminTable from '../../components/AdminTable'
export default {
  name: 'SharedContent',
  components: { AdminTable },
  data() {
    return {
      fields: [
        {
          key: 'first_name',
          label: 'First Name',
          sortable: true
        },
        {
          key: 'last_name',
          label: 'Last Name',
          sortable: true
        },
        {
          key: 'age',
          label: 'Person age',
          sortable: true
        },
        {
          key: 'isActive',
          label: 'Status',
          sortable: true
        }
      ],
      items: [
        { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
        { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson' },
        { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
      ]
    }
  },
  mounted() {
    console.log('call some api for data')
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/SharedContent/SharedContent.vue?c85c370e